import React, { useEffect } from "react";
import { Modal, Form, Input, Button, notification } from "antd";
import { useMutation } from "@tanstack/react-query";
import queryClient from "../queryClient";
import { updatePunchList } from "../services/punchListsAPI";

const UpdatePunchListModal = ({ visible, onClose, punchList }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (punchList) {
      form.setFieldsValue({
        title: punchList.title,
      });
    }
  }, [punchList]);

  const mutation = useMutation({
    mutationFn: updatePunchList,
    onSuccess: () => {
      queryClient.invalidateQueries("punch-lists");
      notification.success({ message: "Punch list updated successfully" });
      onClose();
      form.resetFields();
    },
    onError: (error) => {
      notification.error({
        message: "Failed to update punch list",
        description: error.message,
      });
    },
  });

  const handleUpdatePunchList = (values) => {
    const punchListData = { ...values };
    mutation.mutate({
      punchListId: punchList?._id || punchList?.id,
      punchList: punchListData,
    });
  };

  return (
    <Modal
      title="Update Punch List"
      open={visible}
      onCancel={onClose}
      footer={null}
    >
      <Form form={form} onFinish={handleUpdatePunchList} layout="vertical">
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Please input the title!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={mutation.isLoading}>
            Update
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdatePunchListModal;
